class HeaderSearch extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.openButton = this.querySelector('.btn--open-search-custom');
		this.closeButton = this.querySelector('.btn--close-search-custom');
		this.searchForm = document.querySelector('#HeaderSearch');
		this.preventClose = false;
		this.iniButtons();
		this.handleCloseSearch();
	}

	iniButtons() {
		this.openButton.addEventListener('click', (e) => {
			this.openSearch();
		});

		this.closeButton.addEventListener('click', () => {
			this.closeSearch();
		});
	}

	openSearch() {
		this.searchForm.classList.add('is-active');
		this.openButton.classList.add('hidden');
		this.closeButton.classList.remove('hidden');
	}

	closeSearch() {
		this.searchForm.classList.remove('is-active');
		this.openButton.classList.remove('hidden');
		this.closeButton.classList.add('hidden');
	}

	handleCloseSearch() {
		document.addEventListener('click', (e) => {
			var formIsActive = this.searchForm.classList.contains('is-active');
			var isClickInsideForm = this.searchForm.contains(e.target);
			var isClickInsideOpenButton = this.openButton.contains(e.target);
			if (!isClickInsideForm && formIsActive && !isClickInsideOpenButton) {
				this.closeSearch();
			}
		});
	}
}

customElements.define('header-search', HeaderSearch);
